import { useEffect, useState } from 'react'
import Patient from '../../../../../libs/api/services/Patient'
import PatientProfileSideBarItem from './PatientProfileSideBarItem'

export default function PatientProfileSideBar({ profile, setCategory, category, isOwn }) {
    const [categories, setCategories] = useState([])
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const _load = async () => {
            const _categories = await Patient.Categories(isOwn)
            setCategories(_categories)
        }
        _load()
    }, [profile])


    return (
        <>
            <div className='d-none d-xl-flex col-xl-3 flex-shrink-1 menu-bg flex-xl-column row flex-shrink-1' style={{ overflow: 'auto' }}>
                {
                    categories && categories.length > 0 &&
                    categories.map(cat => cat && cat.resource && <PatientProfileSideBarItem key={cat.resource.id} onSelected={(id) => setCategory({ id: id })} category={cat.resource} active={cat.resource.id === category.id} />)
                }
            </div>
            {/* <div className='flex-shrink-1' style={{ position: 'sticky', top: 0, zIndex: 20 }}>
                <div className='d-flex-column d-xl-none bg-primary-container' style={{ zIndex: 20 }} >
                    <div className='text-center w-100 flex-grow-1'>
                        <button
                            className='btn text-center w-100'
                            onClick={() => setVisible(!visible)}>
                            {category && category.id ? categories.find(c => c.resource && c.resource.id === category.id).resource.groupNme : 'Category'}
                        </button>
                    </div>
                    {visible && <div>
                        {
                            categories && categories.length > 0 &&
                            categories.map(cat => cat && cat.resource && <PatientProfileSideBarItem key={cat.resource.id} onSelected={(id) => {
                                setVisible(false)
                                setCategory({ id: id })
                            }
                            } category={cat.resource} active={cat.resource.id === category.id} />)
                        }
                    </div>}
                </div>
            </div> */}
        </>
    )

    // return (
    //     <>
    //         <div className='d-none d-xl-flex col-xl-3 flex-shrink-1 menu-bg flex-xl-column row'>
    //             <div className='d-none d-xl-flex '>
    //                 {
    //                     profile && profile.userProfile ? <div className='text-light p-3 text-center'>{profile.userProfile.firstName} {profile.userProfile.lastName}</div> : <></>
    //                 }
    //             </div>
    //             {children}
    //         </div>
    //         <div className={`d-flex flex-column d-xl-none -1 menu-bg ${visible ? 'flex-grow-1 h-100' : 'flex-shrink-1'}`}
    //             // style={{ maxWidth: '230px', minWidth: '230px', overflow: 'auto' }}
    //             style={{ overflow: 'auto' }} >

    //             <div className='text-light w-100 p-2'>
    //                 <button
    //                     onClick={() => setVisible(!visible)}
    //                     className='btn w-100 '>
    //                     <div>
    //                         {profile && profile.userProfile ? <div className='text-light p-3 text-center'>{profile.userProfile.firstName} {profile.userProfile.lastName}</div> : <></>}
    //                     </div>
    //                     <div>
    //                         Category
    //                     </div>
    //                 </button>
    //             </div>
    //             {/* <div className='d-none d-xl-flex '>
    //                 {
    //                     profile && profile.userProfile ? <div className='text-light p-3 text-center'>{profile.userProfile.firstName} {profile.userProfile.lastName}</div> : <></>
    //                 }
    //             </div> */}
    //             {visible && children}
    //         </div>
    //     </>
    // )
}
